var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea",class:_vm.classesInput},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label)+"\n    "),_c('textarea',_vm._g(_vm._b({ref:"input",staticClass:"input shadown",class:{'textarea-border-none' : _vm.borderNone},style:([{'color': _vm.colorText }, { 'min-height': _vm.recievedHeight }]),attrs:{"placeholder":_vm.placeholder,"maxlength":_vm.maxlength},domProps:{"value":_vm.internalValue}},'textarea',_vm.$attrs,false),{
        ..._vm.$listeners,
        input: event => _vm.$emit('input', event.target.value),
        mouseup: event => _vm.$emit('highlight', event)
      }))])])
}
var staticRenderFns = []

export { render, staticRenderFns }